export const validate = (_validators, obj, ...args) => {
  if (_validators == null) throw new Error('validator not found');

  const errors = {};
  Object.keys(obj).forEach(key => {
    if (
      Object.prototype.hasOwnProperty.call(_validators, key) &&
      Object.prototype.hasOwnProperty.call(obj, key)
    ) {
      const ret = _validators[key](obj[key], ...args);
      if (ret.error) {
        errors[key] = ret.message;
      }
    }
  });

  return errors;
};

export const arrayToObj = (arr, val) => {
  const hash = {};
  arr.forEach(e => {
    hash[e[val]] = e;
  });

  return hash;
};

export const onEnterKey = (fn, cancel, ctx) => {
  if (typeof fn !== 'function') {
    return () => {};
  }

  return e => {
    if (e.key === 'Enter') {
      fn.call(ctx || this || e, e);

      if (cancel === true) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }

    return true;
  };
};

export const first = (arr, fn) => {
  if (arr == null) throw new Error('arr cannot be null');
  if (fn == null) throw new Error('fn cannot be null');

  var maybe = arr.filter(fn);
  return maybe.length > 0 ? maybe[0] : null;
};
